import type { MarriageAddress } from "@/models"
import { css } from "vite-css-in-js"
import { defineComponent, type ReactiveComponent } from "vue-utils"
import { useEditingMarriageClaimState } from "../state"
import { isEmptyStringOrNull } from "./utils"

const formSectionStyling = css`
	display: grid;
	align-items: center;
	grid-template-columns: repeat(2, 1fr);
	gap: 0.5rem 2rem;

	h6 {
		margin-bottom: 0;
	}

	@media (width < 992px) {
		grid-template-columns: 1fr;
	}
`

const AddressInformation: ReactiveComponent = () => {
	const state = useEditingMarriageClaimState()

	return () =>
		Object.keys(state.fullClaim.Address).filter((key) => state.fullClaim.Address[key as keyof MarriageAddress] !== null)
			.length === 0 ? (
			<h5>No Address Information</h5>
		) : (
			<div class={formSectionStyling}>
				<div class="d-flex gap-1">
					<h6>Address Line 1:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.Address.Address1) ? `Unknown` : state.fullClaim.Address.Address1}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>County:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.Address.County) ? `Unknown` : state.fullClaim.Address.County}
					</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Address Line 2:</h6>
					<h6 class="fw-bold">{state.fullClaim.Address.Address2}</h6>
				</div>
				<div class="d-flex gap-1">
					<h6>Post Code:</h6>
					<h6 class="fw-bold">
						{isEmptyStringOrNull(state.fullClaim.Address.Postcode) ? `Unknown` : state.fullClaim.Address.Postcode}
					</h6>
				</div>
				<div class="d-flex gap-1" data-span="2">
					<h6>Address Line 3:</h6>
					<h6 class="fw-bold">{state.fullClaim.Address.Address3}</h6>
				</div>
			</div>
		)
}

export default defineComponent(AddressInformation)
